<template>
  <v-dialog
    v-model="computedDialogUiHelp"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile three-line>
      <v-toolbar card color="primary">
        <v-btn icon @click.native="methodDialogUi('dialogHelp')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Help</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-list three-line subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Logging in/User permissions</v-list-tile-title>
              <v-list-tile-sub-title>If you have any issues logging in or with user permissions, please contact Heather Dufty or Mike Hamilton.</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Using GeoWB</v-list-tile-title>
              <v-list-tile-sub-title>Please contact Heather Dufty.</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Submit a bug report</v-list-tile-title>
              <v-list-tile-sub-title>Please describe in detail what you were doing, what happened and what the expected outcome was. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    computed: {
      computedDialogUiHelp () {
        return this.$store.state.dialogs.ui.dialogHelp
      }
    },
    methods: {
      methodDialogUi (dialog) {
        this.$store.commit('mutationDialogUi', {
          dialog: dialog
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/dialogHelp.vue